module.exports = __webpack_public_path__ + "static/media/abstract steuart 2.8f845b17.pxm";